import { render, staticRenderFns } from "./e-employee-name-with-icon.vue?vue&type=template&id=aad82a96&scoped=true&lang=pug&"
import script from "./e-employee-name-with-icon.vue?vue&type=script&lang=js&"
export * from "./e-employee-name-with-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad82a96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
